import React, { Component } from 'react';
import { Redirect } from 'react-router';
import { Token } from 'models';


class Authorization extends Component {
  constructor(props) {
    super(props);
    Token.set(props.location.hash.replace('#token/', ''));
  }

  render() {
    return (
      <Redirect to="/console" />
    );
  }
}

export default Authorization;



// WEBPACK FOOTER //
// ./src/components/common/authorization/Authorization.jsx